module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074e3_banner_800x600.39dcb2d8.png";